import IClipboardTool from '@/app/Service/UtilsService/Contract/IClipboardTool';

class ClipboardTool implements IClipboardTool {
  copy = (value: string): Promise<unknown> => navigator.clipboard.writeText(value);
}

export default ClipboardTool;
